import { useState } from "react";
import { TurnstileWidget } from "./TurnstileWidget";

interface ReportFormProps {
  messageId: string;
}

export function ReportForm({ messageId }: ReportFormProps) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("harassment");
  const [context, setContext] = useState("");
  const [token, setToken] = useState("");
  const [status, setStatus] = useState<string | null>(null);

  if (!open) {
    return (
      <button className="report-toggle" type="button" onClick={() => setOpen(true)}>
        Bu mesajı raporla
      </button>
    );
  }

  return (
    <form
      className="report-form"
      onSubmit={(event) => {
        event.preventDefault();
        setStatus("Gönderiliyor…");
        void fetch(`/api/messages/${messageId}/reports`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ reason, context, turnstileToken: token })
        })
          .then(async (response) => {
            if (!response.ok) throw new Error("Rapor gönderilemedi.");
            setStatus("Rapor alındı. İlk rapor mesajı otomatik olarak gizlemez.");
          })
          .catch((error: unknown) =>
            setStatus(error instanceof Error ? error.message : "Rapor gönderilemedi.")
          );
      }}
    >
      <label htmlFor="report-reason">Rapor nedeni</label>
      <select id="report-reason" value={reason} onChange={(event) => setReason(event.target.value)}>
        <option value="threat">Tehdit</option>
        <option value="personal_data">Kişisel bilgi</option>
        <option value="illegal_content">Açıkça hukuka aykırı</option>
        <option value="harassment">Taciz</option>
        <option value="spam">Spam</option>
        <option value="other">Diğer</option>
      </select>
      <label htmlFor="report-context">Kısa açıklama</label>
      <textarea
        id="report-context"
        value={context}
        onChange={(event) => setContext(event.target.value)}
        maxLength={500}
        rows={2}
      />
      <TurnstileWidget onVerify={setToken} />
      <div className="report-form__actions">
        <button type="button" onClick={() => setOpen(false)}>
          Vazgeç
        </button>
        <button type="submit" disabled={!token}>
          Raporu gönder
        </button>
      </div>
      {status && <p>{status}</p>}
    </form>
  );
}
